module.exports = __webpack_public_path__ + "img/logo_white.15660a3d.svg";